import AdminLayout from '@/layouts/AdminLayout.vue';

const adminRoutes = [
  {
    path: '/admin',
    component: AdminLayout,
    meta: { 
      requiresAuth: true,
      role: 'admin'
    },
    children: [
      {
        path: '',
        name: 'AdminHome',
        component: () => import('@/views/admin/Home.vue'),
        meta: { title: '管理员首页' }
      },
      {
        path: 'users/teachers',
        name: 'AdminTeachers',
        component: () => import('@/views/admin/Teachers.vue'),
        meta: { title: '教师管理' }
      },
      {
        path: 'users/students',
        name: 'AdminStudents',
        component: () => import('@/views/admin/Students.vue'),
        meta: { title: '学生管理' }
      },
      {
        path: 'classes',
        name: 'AdminClasses',
        component: () => import('@/views/admin/Classes.vue'),
        meta: { title: '班级管理' }
      },
      {
        path: 'activities',
        name: 'AdminActivities',
        component: () => import('@/views/admin/Activity.vue'),
        meta: { title: '活动管理' }
      },
      {
        path: 'notifications',
        name: 'AdminNotifications',
        component: () => import('@/views/admin/Notification.vue'),
        meta: { title: '通知管理' }
      },
      {
        path: 'evaluations',
        name: 'AdminEvaluations',
        component: () => import('@/views/admin/Evaluations.vue'),
        meta: { title: '评分管理' }
      },
      {
        path: 'document',
        name: 'AdminDocument',
        component: () => import('@/views/admin/Document.vue'),
        meta: { title: '文库管理' }
      },
      {
        path: 'data-monitor/login',
        name: 'AdminLoginMonitor',
        component: () => import('@/views/admin/LoginMonitor.vue'),
        meta: { title: '登录监控' }
      },
      {
        path: 'data-monitor/teachers',
        name: 'AdminTeachersMonitor',
        component: () => import('@/views/admin/TeachersMonitor.vue'),
        meta: { title: '教师数据监控' }
      },
      {
        path: 'attendance/history',
        name: 'AdminAttendanceHistory',
        component: () => import('@/views/admin/AttendanceHistory.vue'),
        meta: { title: '历史考勤' }
      },
      {
        path: 'attendance/today',
        name: 'AdminAttendanceToday',
        component: () => import('@/views/admin/AttendanceToday.vue'),
        meta: { title: '今日考勤' }
      },
      {
        path: 'attendance/teacher',
        name: 'AdminTeacherAttendance',
        component: () => import('@/views/admin/TeacherAttendance.vue'),
        meta: { title: '教师考勤' }
      },
      {
        path: 'attendance/teacher/:schoolCode/:campusCode',
        name: 'AdminTeacherAttendanceWithParams',
        component: () => import('@/views/admin/TeacherAttendance.vue'),
        meta: { title: '教师考勤' },
        props: true
      },
      {
        path: 'attendance/class/:class_id',
        name: 'ClassAttendanceDetail',
        component: () => import('@/views/admin/ClassAttendanceDetail.vue'),
        meta: { 
          title: '班级考勤详情',
          keepAlive: false
        },
        props: true
      },
      {
        path: 'question-bank/knowledge-points',
        name: 'AdminKnowledgePoints',
        component: () => import('@/views/admin/question-bank/KnowledgePoints.vue'),
        meta: { title: '知识点管理' }
      },
      {
        path: 'question-bank/subjects',
        name: 'AdminSubjects',
        component: () => import('@/views/admin/question-bank/Subjects.vue'),
        meta: { title: '学科管理' }
      },
      {
        path: 'question-bank/question-types',
        name: 'AdminQuestionTypes',
        component: () => import('@/views/admin/question-bank/QuestionTypes.vue'),
        meta: { title: '题目类型管理' }
      },
      {
        path: 'question-bank/questions',
        name: 'AdminQuestionBanks',
        component: () => import('@/views/admin/question-bank/QuestionBanks.vue'),
        meta: { title: '题库管理' }
      },
      {
        path: 'question-bank/questions-manage',
        name: 'AdminQuestions',
        component: () => import('@/views/admin/question-bank/Questions.vue'),
        meta: { title: '题目管理' }
      },
      {
        path: 'question-bank/question-creators',
        name: 'AdminQuestionCreators',
        component: () => import('@/views/admin/question-bank/QuestionCreators.vue'),
        meta: { title: '录题人员管理' }
      },
      {
        path: 'question-bank/question-viewers',
        name: 'AdminQuestionViewers',
        component: () => import('@/views/admin/question-bank/QuestionViewers.vue'),
        meta: { title: '查看人员管理' }
      },
      {
        path: 'settings',
        name: 'AdminSettings',
        component: () => import('@/views/admin/Settings.vue'),
        meta: { title: '系统设置' }
      }
    ]
  }
];

export default adminRoutes; 